import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowRightSmall, Message } from '@pets-ui/Icons'
import { Paper } from '@pets-ui/Paper/Paper'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { VStack } from '@pets-ui/VStack/VStack'
import { useState } from 'react'
import { DialogCategoryPromotionAnnouncement } from './DialogCategoryPromotionAnnouncement'

export interface CategoryPromotionAnnouncementProps {
  title: string
  description?: string
  onToggle?: (isOpen: boolean) => void
}

export const CategoryPromotionAnnouncement = (props: CategoryPromotionAnnouncementProps) => {
  const { title, description, onToggle } = props
  const isMobile = useResponsive('tablet')
  const [isOpen, setIsOpen] = useState(false)

  const handleToggleDialog = () => {
    setIsOpen(!isOpen)
    onToggle?.(!isOpen)
  }

  if (!description) return null

  return (
    <>
      <DialogCategoryPromotionAnnouncement open={isOpen} onClose={handleToggleDialog} title={title} description={description} />
      <Paper p={3} position="relative" borderRadius={8} elevation={0}>
        <VStack gap={3}>
          <HStack gap={3} alignItems="center" flexWrap="nowrap">
            <HStack gap={2} alignItems="center" flexShrink={0}>
              <Message fontSize={20} />
              <Text variant="subtitle" fontSize={16}>{title}</Text>
            </HStack>
            {!isMobile && <Text color={colors.grey800} ellipsis>{description}</Text>}
            <Box flexGrow={1} />
            <Box flexShrink={0}>
              <Button variant="text" color="grey" endIcon={<ArrowRightSmall />} onClick={handleToggleDialog}>查看公告</Button>
            </Box>
          </HStack>
          {isMobile && <Text color={colors.grey800} ellipsis>{description}</Text>}
        </VStack>
      </Paper>
    </>
  )
}
